import { jsx } from "panel";
import { SectionEl } from "common/components/section";
import { SelectEl } from "common/components/select";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".retention-query-settings"
  }, /* @__PURE__ */ jsx(SectionEl, {
    attrs: {
      "header-title": `Frequency Criteria`,
      "is-closed": !this.helpers.DEFAULT_COLLAPSIBLE_OPEN,
      "non-collapsible": true
    },
    on: { change: this.helpers.handleCollapsibleQuerySectionChange }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".body"
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: this.helpers.getSelectAttrs(),
    on: {
      menuChange: this.handleSelectMenuChange,
      change: this.helpers.handleSelectChange,
      mouseenter: this.handleSelectMenuMouseEnter,
      mouseleave: this.handleSelectMenuMouseLeave
    }
  }))));
}
